export class ConstantsUrls {

    // used by CpbxLogin.tsx and FaqPage.tsx
    public static readonly ResetPasswortUrl: string = "https://myportal.deutschland-lan.de/hpbx_eup/requestPassword.xhtml";

}
